export const GET_PERMANENCE_REPORT = 'GET_PERMANENCE_REPORT';
export const ERROR = 'ERROR';
export const SET_FILTER = 'SET_FILTER';
export const GET_PERMANENCE_REPORT_TOTALS = 'GET_PERMANENCE_REPORT_TOTALS';
export const ERROR_TOTALS = 'ERROR_TOTALS';
export const IS_FETCHING_TOTALS = 'IS_FETCHING_TOTALS';
export const DOWNLOADING = 'DOWNLOADING';
